import * as actionTypes from '../actionTypes';

export const getDocuments = function () {
  return { type: actionTypes.GET_DOCUMENTS };
};
